module.exports = __webpack_public_path__ + "static/mapSelector2-64ce071f4f3fafbedb0a928f211dc7d9.png";